<div mat-dialog-content>
  <div class="container-fluid">
    <!-- CARD-TITLE -->
    <div class="col-12 mb-4">
      <p class="two-factor-title c-blue">
        Verificación de seguridad
      </p>
    </div>
    <!-- CARD-TITLE -->

    <!-- DIVIDER -->
    <div class="col-12 mb-4">
      <mat-divider></mat-divider>
    </div>
    <!-- DIVIDER -->

    <!-- CARD-SUBTITLE -->
    <div class="col-12 mb-4 mt-2">
      <p class="two-factor-subtitle c-blue mb-0">
        Para su seguridad, hemos enviado un código de seguridad a su email
      </p>
    </div>
    <!-- CARD-SUBTITLE -->

    <!-- DIVIDER -->
    <div class="col-12 mb-4 mt-2">
      <mat-divider></mat-divider>
    </div>
    <!-- DIVIDER -->

    <!-- ENTER-CODE-TITLE -->
    <div class="col-12 mb-4 mt-2">
      <p class="two-factor-enter-code c-blue mb-0">
        Por favor ingrese el código recibido aquí:
      </p>
    </div>
    <!-- ENTER-CODE-TITLE -->

    <!-- ENTER-CODE-INPUT -->
    <div class="col-12 mb-4 mt-2">
      <form [formGroup]="this.twoFactorForm">
        <mat-form-field appearance="outline" class="w-100 pr-2 pl-2 pt-0 pb-0">
          <input matInput formControlName="VerificationCode" maxlength="6" type="text"
            placeholder="Ingrese aquí el código de seguridad">
          <mat-icon matSuffix>vpn_key</mat-icon>
          <mat-error *ngIf="twoFactorForm.controls['VerificationCode'].hasError('required')">
            {{ 'language.error' | translate }}
          </mat-error>
        </mat-form-field>
      </form>
    </div>
    <!-- ENTER-CODE-INPUT -->

    <!-- RESEND-CODE-QUESTION -->
    <div class="col-12 text-center mb-2 mt-2">
      <span class="two-factor-resend-code c-blue mb-2">
        ¿No recibió su código?
      </span>
    </div>
    <!-- RESEND-CODE-QUESTION -->

    <!-- COUNT DOWN -->
    <div class="col-12 mb-4 text-center" *ngIf="this.countDown !== 0 && showCountDownText">
      <span class="two-factor-resend-code c-blue">
        Espere <b>{{this.formattedTime}}</b> para solicitarlo nuevamente.
      </span>
    </div>
    <!-- COUNT DOWN -->

    <!-- RESEND-CODE-BUTTON -->
    <div class="col-12 mb-4 mt-2">
      <button mat-stroked-button [disabled]="this.countDown !== 0 && showCountDownText" class="w-100"
        (click)="tryResendCode()">
        <span *ngIf="this.countDown == 0">Volver a enviar código</span>
        <div class="d-flex align-items-center justify-content-center" *ngIf="this.countDown !== 0">
          <mat-spinner [diameter]="15" class="resend-code-spinner mr-2"></mat-spinner>
          <span>Aguarde</span>
        </div>
      </button>
    </div>
    <!-- RESEND-CODE-BUTTON -->

    <!-- VALIDATE-BUTTON -->
    <div class="col-12">
      <button mat-stroked-button [disabled]="this.twoFactorForm.invalid" class="custom-validate-btn w-100"
        (click)="validateCode()">
        <span *ngIf="!validatingCode">
          Validar código
        </span>
        <div>
          <div class="d-flex align-items-center justify-content-center" *ngIf="validatingCode">
            <mat-spinner [diameter]="15" class="validate-spinner mr-2"></mat-spinner>
            <span>Validando</span>
          </div>
        </div>
      </button>
    </div>
    <!-- VALIDATE-BUTTON -->
  </div>
</div>
